<template>
    <div class="text-center">
        <b-row>
            <b-col cols="3">
                <summary-item 
                    :title="'Hoy'"
                    :day="today"
                    :anchor="'#today'"
                />
            </b-col>
            <b-col cols="3">
                <summary-item 
                    :title="'Mañana'"
                    :day="tomorrow"
                    :anchor="'#tomorrow'"
                />
            </b-col>
            <b-col cols="3">
                <summary-item 
                    :title="'Hoy +2'"
                    :day="twoDays"
                    :anchor="'#twoDays'"
                />
            </b-col>
            <b-col cols="3">
                <summary-item 
                    :title="'Hoy +3'"
                    :day="threeDays"
                    :anchor="'#threeDays'"
                />
            </b-col>

        </b-row>
    </div>
    
</template>

<script>
import SummaryItem from "./SummaryItem"

export default {
    components: {
        SummaryItem
    },
    computed: {
        today() {
            return this.$moment()
        }, 
        tomorrow() {
            return this.$moment().add(1,'days')
        },
        twoDays() {
            return this.$moment().add(2,'days')
        },
        threeDays() {
            return this.$moment().add(3,'days')
        }
    }
}
</script>